import { React, useEffect, useState } from "react";
import { CheckCircleTwoTone, CloseCircleTwoTone } from "@ant-design/icons";
import {
  Alert,
  Button,
  Collapse,
  Modal,
  Space,
  Typography,
  message,
} from "antd";
import { useUpdateProjectStatusMutation } from "../../../store/is/projectapi";

export default function SubmitToPublicConsultation({
  isCreate,
  closeModal,
  interventionDetails,
  usergroup,
  handleDispatchSubmitToPublicConsultation,
}) {
  const key = "updatable";

  const [
    openSubmitToPublicConsultationConfirmModal,
    setOpenSubmitToPublicConsultationConfirmModal,
  ] = useState(false);
  const [
    confirmSubmitToPublicConsultationModal,
    setConfirmLoadingSubmitToPublicConsultationModal,
  ] = useState(false);

  const [updateProjectStatus] = useUpdateProjectStatusMutation();

  useEffect(() => {
    if (isCreate) {
      setOpenSubmitToPublicConsultationConfirmModal(true);
    }
  }, [isCreate]);

  const handleOkOfSubmitToPublicConsultationModal = async () => {
    let interventionUpdateResponse;
    const intervstatusupdate = { ...interventionDetails };
    intervstatusupdate["status"] = "Public Consultation";

    try {
      if (!usergroup.includes("Proba Operator")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        interventionUpdateResponse = await handleIntervEditRecord(
          intervstatusupdate
        );
      }
    } catch (error) {
      console.error("Error updating intervention:", error);
    } finally {
      setConfirmLoadingSubmitToPublicConsultationModal(false);
    }
  };

  const handleCancelOfSubmitToRevisionModal = async () => {
    let interventionUpdateResponse;
    const intervstatusupdate = { ...interventionDetails };
    intervstatusupdate["status"] = "Revision";

    try {
      if (!usergroup.includes("Proba Operator")) {
        message.error({
          content: "Action Prohibited",
          key,
          duration: 6,
        });
      } else {
        interventionUpdateResponse = await handleIntervEditRecord(
          intervstatusupdate
        );
      }
    } catch (error) {
      console.error("Error updating intervention:", error);
    } finally {
      setConfirmLoadingSubmitToPublicConsultationModal(false);
    }
  };

  const handleCloseModal = () => {
    setOpenSubmitToPublicConsultationConfirmModal(false);
    closeModal();
  };

  const handleIntervEditRecord = async (record) => {
    try {
      const payload = {
        id: record._id,
        body: record,
      };
      console.log("payload", payload);
      const res = await updateProjectStatus(payload)
        .unwrap()
        .then((res) => {
          message.success({
            content: "GHG Project updated successfully!",
            key,
            duration: 2,
          });
          console.log(res);
          handleDispatchSubmitToPublicConsultation(res);
          setOpenSubmitToPublicConsultationConfirmModal(false);
          return res;
        })
        .catch((err) => {
          console.log("err", err);
          message.error({
            content:
              "Failed to update GHG Project: " + Object.values(err["data"])[0],
            key,
            duration: 6,
          });
          console.log(err);
        });
      return res;
    } catch {}
  };

  return (
    <div>
      <>
        {isCreate ? (
          <SubmitToPublicConsultationModal
            visible={isCreate}
            openSubmitToPublicConsultationConfirmModal={
              openSubmitToPublicConsultationConfirmModal
            }
            handleOkOfSubmitToPublicConsultationModal={
              handleOkOfSubmitToPublicConsultationModal
            }
            handleCancelOfSubmitToRevisionModal={
              handleCancelOfSubmitToRevisionModal
            }
            confirmSubmitToPublicConsultationModal={
              confirmSubmitToPublicConsultationModal
            }
            handleCloseModal={handleCloseModal}
          />
        ) : null}
      </>
    </div>
  );
}

const isSubmitToPublicConsultationDisabled = false;
const SubmitToPublicConsultationModal = ({
  visible,
  openSubmitToPublicConsultationConfirmModal,
  handleOkOfSubmitToPublicConsultationModal,
  handleCancelOfSubmitToRevisionModal,
  confirmSubmitToPublicConsultationModal,
  handleCloseModal,
}) => {
  const { Panel } = Collapse;
  const { Text, Paragraph } = Typography;

  const renderEligibilityCheckPanelContent = () => {
    return null;
  };

  const renderOperationalCheckPanelContent = () => {
    return null;
  };

  return (
    <Modal
      title="Submit for Public Consultation"
      open={openSubmitToPublicConsultationConfirmModal}
      onOk={handleOkOfSubmitToPublicConsultationModal}
      okText="Submit for Public Consultation"
      confirmLoading={confirmSubmitToPublicConsultationModal}
      onCancel={handleCloseModal}
      footer={[
        <Button
          key="cancel"
          onClick={handleCancelOfSubmitToRevisionModal}
          style={{ color: "red" }}
        >
          Revise
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleOkOfSubmitToPublicConsultationModal}
          loading={confirmSubmitToPublicConsultationModal}
        >
          Submit for Public Consultation
        </Button>,
      ]}
    >
      <Alert
        message="Before submitting to Public Consultation, please ensure you have performed the Eligibility checks."
        banner
        closable
        style={{ marginBottom: "16px" }}
      />
      {isSubmitToPublicConsultationDisabled === false ? (
        <p>
          The project is ready for Public Consultation. Do you want to submit for
          Public Consultation?
        </p>
      ) : (
        <>
            <p>
              Please fix the following errors to make the project ready for Public
              Consultation
            </p>

          <Collapse defaultActiveKey={["EligibilityCheck", "OperationalCheck"]}>
            {renderEligibilityCheckPanelContent() !== null && (
              <Panel
                header={
                  <Space>
                    <Text strong>Errors in Eligibility Check</Text>
                    {renderEligibilityCheckPanelContent() === null ? (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    ) : (
                      <CloseCircleTwoTone twoToneColor="#eb2f96" />
                    )}
                  </Space>
                }
                key="project"
              >
                {renderEligibilityCheckPanelContent()}
              </Panel>
            )}
            {renderOperationalCheckPanelContent() !== null && (
              <Panel
                header={
                  <Space>
                    <Text strong>Errors in Eligibility Check</Text>
                    {renderOperationalCheckPanelContent() === null ? (
                      <CheckCircleTwoTone twoToneColor="#52c41a" />
                    ) : (
                      <CloseCircleTwoTone twoToneColor="#eb2f96" />
                    )}
                  </Space>
                }
                key="assets"
              >
                {renderOperationalCheckPanelContent()}
              </Panel>
            )}
          </Collapse>
        </>
      )}
    </Modal>
  );
};
